/// <reference lib="webworker" />

import { PostMessageInput, PostMessageInputData, PostMessageOutputData } from '../service-worker/service-worker.types';

export enum TokenMessageType {
  SET_TOKEN = 'SET_TOKEN'
}

export interface TokenMessageInputData extends PostMessageInputData<TokenMessageType> {
  tokenStore: {
    enabled?: boolean;
    requestUrls?: string[];
    token?: string;
  };
}

export type TokenMessageInput = PostMessageInput<TokenMessageInputData>;

export interface TokenMessageOutputData extends PostMessageOutputData {
  tokenStore: {
    hasToken: boolean;
  };
}
